const {minimize_str} = require("@core/helpers/string");

export const GET_MEGA_MENU = minimize_str(`
 query ($menu_key: String) {
    result : getMegaMenuByKey(key: $menu_key) {
      id
      value # json
    }
  }
`);

export const GET_MEGA_MENUS = minimize_str(`
  query ($menu_keys: [String]) {
     result : getMegaMenuByKeys(key: $menu_keys) {
       key
       value # json
     }
   }
 `);
